import Api from '../api/Api';
import resolve from  '../util/Configuracao';
class ArquivoXMLApi extends Api {
  async validarArquivo (file) {
    const validarArquivoUrl = resolve('urlValidarArquivo');
    const result = await this.fetch(validarArquivoUrl, 'post', file);
    return result;
  }
  async auditarArquivo (file) {
    const auditarArquivoUrl = resolve('urlAuditarArquivo');
    const result = await this.fetch(auditarArquivoUrl, 'post', file);
    return result;
  }
  async consultarParametrosEnvio () {
    try {
      const urlConsultarParametrosEnvio = resolve('urlConsultarParametrosEnvio');
      const response = await this.fetch(urlConsultarParametrosEnvio, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return '';
    }
  }
  async enviarArquivo (file, usuario, ipUsuario, autenticacao) {
    var encode = 'ISO-8859-1';
    var cabecalho = file.conteudo.substring(0, 50).toUpperCase();
    if (cabecalho.includes('UTF-8')) {
      encode = 'UTF-8';
    } else if (cabecalho.includes('ISO-8859-1')) {
      encode = 'ISO-8859-1';
    }
    var arquivoParaEnvio = {
      nomeArquivo: file.nome,
      conteudo: file.conteudo,
      usuario: usuario,
      ipUsuario: ipUsuario,
      encode: encode,
      autenticacao: autenticacao
    };
    try {
      const enviarArquivoUrl = resolve('enviarArquivoUrl');
      const result = await this.fetch(enviarArquivoUrl, 'post', arquivoParaEnvio);
      return result;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarProtocolo (codProtocolo) {
    try {
      const urlConsultarProtocolo = resolve('urlConsultarProtocolo') + codProtocolo;
      const response = await this.fetch(urlConsultarProtocolo, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return '';
    }
  }
  async listarProtocolos (filter) {
    let indReapresentacao = filter.indReapresentacao === undefined ? 'N' : filter.indReapresentacao;
    try {
      const urlListarProtocolos = resolve('urlListarProtocolos') + filter.numProtocolo + '/seqPrestador/' + filter.seqPrestador + '/nome/' + filter.nomePrestador + '/data_inicio/' + filter.dataInicio + '/data_fim/' + filter.dataFim + '/indReapresentacao/' + indReapresentacao;
      const response = await this.fetch(urlListarProtocolos, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return '';
    }
  }
  async abrirXml (txtObjetoGed) {
    try {
      const urlAbrirXml = resolve('urlAbrirXml') + txtObjetoGed;
      const response = await this.fetch(urlAbrirXml, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return '';
    }
  }
  recuperaMensagemNotaFiscal (valorOrcamentoUniao, valorPlanoTstSaude) {
    var CNPJ_UNIAO_FORMATADO = '00.509.968/0001-48';
    var CNPJ_PLANO_SAUDE_FORMATADO = '08.512.284/0001-07';
    var mensagem = [];
    var i = 0;
    mensagem[i] = 'Lote de guias recebido com sucesso. A análise dos valores enviados indica que, se não houver glosa, você deverá emitir a(s) seguinte(s) nota(s) fiscal(is):';
    i++;
    if (valorOrcamentoUniao !== 0) {
      mensagem[i] = 'CNPJ: ' + CNPJ_UNIAO_FORMATADO;
      i++;
      mensagem[i] = 'TRIBUNAL SUPERIOR DO TRABALHO - Total: ' + new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(valorOrcamentoUniao);
      i++;
    }
    if (valorPlanoTstSaude !== 0) {
      mensagem[i] = 'CNPJ: ' + CNPJ_PLANO_SAUDE_FORMATADO;
      i++;
      mensagem[i] = 'PROGRAMA DE ASSISTÊNCIA À SAÚDE (TST-SAÚDE) - Total: ' + new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(valorPlanoTstSaude);
      i++;
    }
    mensagem[i] = 'Endereço para envio:';
    i++;
    mensagem[i] = 'SAFS QUADRA 08 LOTE 01 BLOCO A SALA 22';
    i++;
    mensagem[i] = 'BRASÍLIA-DF';
    i++;
    mensagem[i] = 'CEP: 70700-600';
    i++;
    mensagem[i] = '- As certidões do INSS (certidão de débitos relativos às contribuições previdenciárias e às de terceiros), da Receita Federal (Certidão de débitos relativos aos tributos Federais e à Divida Ativa da União) e  do FGTS (Certificado de Regularidade do FGTS - CRF) devem estar válidas para que as notas sejam liquidadas.';
    i++;
    mensagem[i] = '- Em caso de dúvida, favor enviar e-mail para: faturamentotstsaude@tst.jus.br';

    return mensagem;
  }
}
export default ArquivoXMLApi;
